import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

const PriceWithPromo = ({ promoRate }: { promoRate: number }) => {
  const { t } = useTranslation('ShopAddons');

  return promoRate > 0 ? (
    <Txt variant="bodySmallBold" color="success" data-testid="priceWithoutDiscount" component="span">
      {`$${promoRate.toFixed(2)}`}
      <Txt variant="bodySmallBold" color="success" component="span" data-testid="durationPeriod">
        {t('DurationPeriod.Month')}
      </Txt>
    </Txt>
  ) : (
    <Txt variant="bodySmallBold" color="success" data-testid="freeText" component="span">
      {t('FreeText')}
    </Txt>
  );
};

const PriceWithoutPromo = ({ price }: { price: number }) => {
  const { t } = useTranslation('ShopAddons');

  return (
    <Txt variant="bodySmallBold" color="regular" data-testid="priceWithoutDiscount" component="span">
      {price ? (
        <>
          ${price.toFixed(2)}
          <Txt component="span" variant="smallBold" color="regular" data-testid="durationPeriod">
            {t('DurationPeriod.Month')}
          </Txt>
        </>
      ) : (
        <Txt variant="smallBold" color="success" data-testid="freeAddOn">
          {t('FreeText')}
        </Txt>
      )}
    </Txt>
  );
};

type PromoDetailsProps = {
  promotionAmount: number;
  priceWithoutPromo: number;
  duration: number;
  priceAfterDiscountExpiration: string;
};

export const PromoDetails = ({
  promotionAmount,
  priceWithoutPromo,
  duration,
  priceAfterDiscountExpiration,
}: PromoDetailsProps) => {
  const { t } = useTranslation('ShopAddons');
  // Catalog sets promotionAmount as a negative number
  const promoRate = priceWithoutPromo + promotionAmount;

  return promotionAmount ? (
    <>
      <PriceWithPromo promoRate={promoRate} />
      <Txt data-testid="durationPeriodInfo" component="span">
        <Txt
          variant="bodySmallBold"
          color="success"
          data-testid="addonPriceDiscountDurationPeriod"
          ml="4px"
          component="span"
        >
          {t('priceBeforePromotion', { count: duration })}
        </Txt>
      </Txt>
      {` - ${priceAfterDiscountExpiration}`}
    </>
  ) : (
    <PriceWithoutPromo price={priceWithoutPromo} />
  );
};
